import * as React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { Pagination } from 'components';
import { AuthContextType } from 'contexts';
import useGetExclusivesQueue from './hooks/useGetExclusivesQueue';

interface ExclusivesQueueProps {
  auth: AuthContextType['auth'];
  locations: string[];
  setExclusivesCount: (exCount: number) => void;
  $rootScope: {
    hasFeature: AuthContextType['hasFeature'];
  };
  $window: ng.IWindowService;
}
// TODO: Refactor classnames to antd components for admin queue redesign
const ExclusivesQueue: React.FC<ExclusivesQueueProps> = ({
  auth,
  locations = [],
  setExclusivesCount,
  $rootScope: { hasFeature },
  $window,
}) => {
  const isAuthorized = hasFeature('CREATE_LISTING');

  const { sort, isLoading, data, pageHandler, totalCount, query } =
    useGetExclusivesQueue({
      locationIndices: locations,
      isAuthorized,
      setExclusivesCount,
    });

  if (!isAuthorized) {
    $window.location.assign('/#/feature-missing');
    return null;
  }

  if (isLoading) {
    return (
      <div className="col-md-2 col-md-offset-5 spin">
        <i className="fa fa-spinner fa-spin" />
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <table
        className="table table-striped table-bordered table-hover table-queue"
        data-cy="paperwork-table"
      >
        <thead>
          <StyledTr>
            <th>
              <a onClick={() => sort('line1')}>Address</a>
            </th>
            <th>Agents</th>
            <th>
              <a onClick={() => sort('location')}>Branch</a>
            </th>
            <th>
              <a onClick={() => sort('date')}>Date Submitted</a>
            </th>
            <th />
          </StyledTr>
        </thead>
        <tbody>
          {data?.length ? (
            data.map(
              ({ id, line1, reps, location, line2, documentSubmission }) => (
                <StyledTr
                  onClick={() => {
                    window.location.href = `/#/listing/${id}/edit`;
                  }}
                  key={id}
                  data-cy={`paperwork-row-${id}`}
                >
                  <td data-cy={`paperwork-address-${id}`}>
                    {line1} {line2}
                  </td>
                  <td data-cy={`paperwork-agent-${id}`}>
                    {reps?.length > 0
                      ? reps.map(rep => (
                          <div key={rep.id}>
                            {rep.firstName} {rep.lastName || ''}
                          </div>
                        ))
                      : '-'}
                  </td>
                  <td data-cy={`paperwork-branch-${id}`}>
                    {auth?.org?.locations?.[Number(location)]?.name}
                  </td>
                  <td data-cy={`paperwork-date-${id}`}>
                    <div>
                      {moment(documentSubmission?.date).format(
                        'MMM D, YYYY h:mm:ss A',
                      )}
                    </div>
                    <div>By: {documentSubmission?.userName}</div>
                  </td>
                  <td data-cy={`paperwork-verify-${id}`}>
                    <a
                      href={`/#/listing/${id}/documents/all`}
                      className="btn btn-primary"
                      data-cy={`paperwork-verify-button-${id}`}
                    >
                      Verify Listing Documents
                    </a>
                  </td>
                </StyledTr>
              ),
            )
          ) : (
            <tr>
              <td colSpan={5}>No pending documents to review</td>
            </tr>
          )}
        </tbody>
      </table>
      {totalCount > 20 && (
        <Pagination
          total={totalCount}
          defaultPageSize={20}
          current={query.page}
          onChange={pageHandler}
        />
      )}
    </div>
  );
};

const StyledTr = styled.tr`
  /* todo: currently using !important and using && doesn't seem to override it */
  td {
    vertical-align: middle !important;
  }
  th {
    padding: 10px;
  }
`;
export default ExclusivesQueue;
